import "./home.scss";
import Widget from "../../components/widget/Widget";
import "../../components/datatable/datatable.scss";
import Datatable from "../../components/datatable/Datatable"
import { allUserAssetsColumns} from "../../datatablesource";
import { useState } from "react";
import { useEffect } from "react";
import newRequest from "../../utils/newRequest";
import { handleError} from "../../utils/error";
import { useTranslation } from "react-i18next";
const Home = () => {
  const { t } = useTranslation();
  const [allAssetsList, setAllAssetsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);


  useEffect(() => {
    setIsLoading(true);
    const getAllAssetsList = async () => {
      try {
        newRequest.get("/GetAllAssetMasterEncodeAssetCaptureFinal", data)
          .then(response => {
            setAllAssetsList(response?.data ?? []);
            setIsLoading(false)
          })
          .catch(error => {
            handleError(error)
            console.error(error);
            setIsLoading(false)
          });
      }
      catch (error) {
        handleError(error)
      }
    };
    getAllAssetsList();
  }, []);
  return (
    <>
      <div className="home">
        {/* <Sidebar /> */}
        <div className="homeContainer">
          {/* <Navbar /> */}

          <div className="widgets">
            <Widget type="allUser" />
            <Widget type="activeUser" />
            <Widget type="inActiveUser" />
          </div>
          <Datatable
            secondaryColor="secondary"
            data={allAssetsList}
            columnsName={allUserAssetsColumns(t)}
            title={"VERIFIED ASSETS"}
            deleteBtnEndPoint="/DeleteAssetMasterEncodeAssetCaptureFinalById"
            // checkboxSelectionOption={false}
            loading={isLoading}
            uniqueId={"verifedAssetId"}
          />

        </div>
      </div>
    </>
  );
};



export default Home;
